import React from 'react';

import { GradCtaHeroBlockData } from 'api/cms';
import { AmpHeroBlock } from 'cms/blocks/Amp/AmpHeroBlock';
import { AmpBlockMappingComponentProps } from 'cms/blocks/BlockMapping';

export function AmpGradCtaHeroBlock({
  content,
  data,
  blockId,
}: AmpBlockMappingComponentProps<GradCtaHeroBlockData>) {
  return (
    <AmpHeroBlock
      content={content}
      data={{
        ...data,
        isGrad: true,
        buttonText: undefined,
        buttonUrl: undefined,
      }}
      blockId={blockId}
    />
  );
}
